import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectCurrentSession, setCurrentSession } from "../../features/sessions/sessions-slice";
import { BookingMode } from "../../features/sessions/enums/BookingMode";

interface SessionBookingModeFieldProps {
  disabled?: boolean;
}

const OPTIONS: Array<{ mode: BookingMode; key: string; fallback: string }> = [
  { mode: BookingMode.Closed, key: "sessionForm.bookingMode.closed", fallback: "Closed — only you add people" },
  {
    mode: BookingMode.OpenAutoConfirm,
    key: "sessionForm.bookingMode.openAuto",
    fallback: "Open — bookings confirm themselves",
  },
  {
    mode: BookingMode.OpenWithConfirmation,
    key: "sessionForm.bookingMode.openConfirm",
    fallback: "Open — you confirm each booking",
  },
];

/** The session form's portal booking mode; reads and writes the session being edited. */
const SessionBookingModeField = ({ disabled = false }: SessionBookingModeFieldProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const currentSession = useAppSelector(selectCurrentSession);

  return (
    <label className="block text-sm font-medium text-grey-30 dark:text-grey-70">
      {t("sessionForm.bookingMode.label", "Booking from the member portal")}
      <select
        className="input mt-1 w-full sm:w-80"
        value={currentSession?.bookingMode ?? BookingMode.Closed}
        disabled={disabled || !currentSession}
        onChange={(event) => {
          if (!currentSession) return;
          dispatch(
            setCurrentSession({ ...currentSession, bookingMode: event.target.value as BookingMode }),
          );
        }}
      >
        {OPTIONS.map((option) => (
          <option key={option.mode} value={option.mode}>
            {t(option.key, option.fallback)}
          </option>
        ))}
      </select>
    </label>
  );
};

export default SessionBookingModeField;
